import { forwardRef, ReactNode } from "react";
import { Flex, Text, Image } from "rebass/styled-components";
import styled from "styled-components";

import { Thumbnail, ThumbnailImage } from "../ThumbnailRow";
import { getMetadataValue } from "../../Utilities";
import { PlaylistClip, IClipWithMetadata } from "../../@types";

import { formatNumber } from "MVVM/Utilities/Clip";
import { formatRelativeTime } from "MVVM/Utilities/Time";

export const HorizontalThumbnail = forwardRef<
  HTMLDivElement,
  {
    thumbnail: PlaylistClip;
    handleThumbnailClick: (thumbnail: PlaylistClip) => void;
    activePlaylistClip: IClipWithMetadata | null;
    renderLolPlaylist: boolean;
    socialInfo?: ReactNode;
  }
>(
  (
    {
      thumbnail,
      handleThumbnailClick,
      activePlaylistClip,
      renderLolPlaylist,
      socialInfo,
    },
    ref,
  ) => {
    const profileIcon =
      getMetadataValue(thumbnail?.metadata, "Profile Icon") || "1";
    return (
      <StyledContainer>
        <Thumbnail
          ref={ref}
          key={thumbnail._id}
          onClick={() => handleThumbnailClick(thumbnail)}
          $renderLolPlaylist={renderLolPlaylist}
          $active={
            activePlaylistClip
              ? activePlaylistClip.internalId === thumbnail.internalId
              : false
          }
          $isHorizontalLayout={true}
        >
          <ThumbnailImage
            src={
              thumbnail.thumbnailOverlayUrl || thumbnail.thumbnailStandardUrl
            }
            loading="lazy"
            $isHorizontalLayout={true}
          />
          {socialInfo}
        </Thumbnail>
        <StyledTextContainer>
          <StyledProfileImage
            src={`${process.env.REACT_APP_S3_CLIP_BUCKET}/static/web/lol/summoner_icons/${profileIcon}.png`}
          />
          <Flex flexDirection="column">
            <StyledTitleText>{thumbnail.title}</StyledTitleText>
            <StyledDetailsText>
              {formatNumber(thumbnail.views)} views •{" "}
              {formatRelativeTime(thumbnail.createdDate)}
            </StyledDetailsText>
          </Flex>
        </StyledTextContainer>
      </StyledContainer>
    );
  },
);

const StyledContainer = styled(Flex)`
  flex-direction: column;
  flex-shrink: 0;
  gap: 8px;
  height: 100%;
  max-height: 100%;
`;

const StyledTextContainer = styled(Flex)`
  flex-wrap: nowrap;
  gap: 12px;
`;

const StyledProfileImage = styled(Image)`
  border-radius: 100px;
  height: 32px;
  width: 32px;
`;

const StyledTitleText = styled(Text)`
  color: white;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

const StyledDetailsText = styled(Text)`
  color: #9e9eb1;
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
`;
